/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateOrganizationPaymentBillingInfoSetupIntentResponseData
 */
export interface CreateOrganizationPaymentBillingInfoSetupIntentResponseData {
  /**
   *
   * @type {string}
   * @memberof CreateOrganizationPaymentBillingInfoSetupIntentResponseData
   */
  clientSecret: string
}

export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSON(
  json: any
): CreateOrganizationPaymentBillingInfoSetupIntentResponseData {
  return CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSONTyped(json, false)
}

export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateOrganizationPaymentBillingInfoSetupIntentResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    clientSecret: json['client_secret']
  }
}

export function CreateOrganizationPaymentBillingInfoSetupIntentResponseDataToJSON(
  value?: CreateOrganizationPaymentBillingInfoSetupIntentResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    client_secret: value.clientSecret
  }
}
